import { RouteConfig } from 'vue-router';

import { EntityType } from '@/enums/entityType.enum';
import { Errors } from '@/enums/errors.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';

export const documentSystemNumbersRoute: RouteConfig = {
  path: 'systemNumbers',
  name: 'documentSystemNumbers',
  component: () =>
    import(/* webpackChunkName: "SystemNumbers" */ '@/views/mainRoute/document/details/SystemNumbers.vue'),
  beforeEnter: (to, from, next) => {
    store.commit('document/setId', tryParseInt(to.params.documentId));
    return store
      .dispatch('document/get')
      .then(document =>
        store.dispatch('setting/findPublic', {
          code: PublicSettings.HIDE_JO_SYSTEM_NUMBERS,
          entityType: EntityType.PROCEDURE,
          entityId: document.procedureId.toString()
        })
      )
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.DOCUMENT_CANNOT_GET }));
  }
};
